import { Injectable } from '@angular/core';
import authHeader from '../helpers/auth-header';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { map, catchError } from 'rxjs';
import { Customer } from '../interfaces/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

     constructor (private http: HttpClient) { }

     getExistingCustomer(customerName: string, countryAbbr: string, stateAbbr: string): Customer | any {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };
          if (customerName && countryAbbr && stateAbbr) {
               const url = `${environment.APP_API_URL}/api/v1/Customers/getCustomerMatch/${customerName}/${countryAbbr}/${stateAbbr}`;
               return this.http.get(url, config)
                    .pipe(
                         map((response: Customer | null) => {
                              if (response) {
                                   const match = response as Customer;
                                   return match;
                              }
                              return null;
                         }),
                         catchError(error => {
                              console.error(error);
                              return [];
                         })
                    )

          } else {
               return null;
          }
     }
}
